import { useCurrentUser } from './useCurrentUser.context';

export type { UserType } from './useCurrentUser.context';

export interface UseUserTypeResult {
    userType: import('./useCurrentUser.context').UserType | null;
    isAdmin: boolean;
    loading: boolean;
}

export function useUserType(): UseUserTypeResult {
    const { userType, isAdmin, loading } = useCurrentUser();
    return { userType, isAdmin, loading };
}
